import React, {useState, useEffect} from 'react';
import {  Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import BasicInformationsTab from './BasicInformationsTab';
import BankAccountsTab from '../bankAccount/BankAccountsTab';
import FileTab from '../file/FileTab';
import ContractTab from '../contract/ContractTab';


const PartnerModal = (props) => {
   
    const [t] = useTranslation();
    const [show, setShow] = useState(false);  
    const [selectedRecord, setSelectedRecord] =  useState();  
    const [activeTab, setActiveTab] = useState('BASIC_INFORMATIONS');
    const [windowTitle, setWindowTitle] = useState(t('partner.label.'+props.partnerType));
    
   // const [selectedRecord,setSelectedRecord] = useState(props.selectedRecord);  
    

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const loadedPartner = (partner) => {
        
        if(partner!=null && partner.id!=null && partner.id!==''){
            setSelectedRecord(partner.id);
        }
        try{
            if(partner.address.firstName && partner.address.lastName){
                setWindowTitle(partner.address.firstName+" "+partner.address.lastName);
            }else if(partner.address.name){
                setWindowTitle(partner.address.name);                
            }else{
                setWindowTitle(t('partner.label.'+props.partnerType));
            }
            
        }catch(error){
               console.log(error);
        }
       // console.log(partner.address.name);
    }

    const hideModal = () => {
      setShow(false);     
      props.parentCallback(false,selectedRecord);
    };
   
    useEffect(() => {
      setShow(props.show);
    }, [props.show])

    useEffect(() => {
      setSelectedRecord(props.selectedRecord);      
    }, [props.selectedRecord])

    return (
 
 
      <>         
                <Modal
                  show={show}
                  onHide={hideModal}
                  container={this}
                  aria-labelledby="contained-modal-title"
                //  centered
                  size="lg"                       //xl
                                   
                >
                    
                  <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title">{windowTitle}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>

                    <div className="row"></div>
                            <div className="col-12 col-sm-12 col-lg-12" style={{margin: '0 auto',float: 'none'}}>
                                <div className="card card-primary card-outline card-tabs">
                                    <div className="card-header p-0 pt-1 border-bottom-0">
                                        <ul className="nav nav-tabs" role="tablist">
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'BASIC_INFORMATIONS'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('BASIC_INFORMATIONS')
                                                    }
                                                >
                                                    {t('partner.label.basicInformations')}
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'BANK_ACCOUNT'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('BANK_ACCOUNT')
                                                    }
                                                >
                                                    {t('bankAccount.label.bankAccounts')}
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'CONTRACT'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('CONTRACT')
                                                    }
                                                >
                                                    {t('partner.label.contract')}
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'FILES'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('FILES')
                                                    }
                                                >
                                                    {t('file.label.files')}
                                                </button>
                                            </li>                                          
                                        </ul>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content">
                                            <BasicInformationsTab
                                                isActive={activeTab === 'BASIC_INFORMATIONS'}
                                                parentCallback={hideModal}
                                                selectedRecord={selectedRecord}
                                                loadedPartner={loadedPartner}
                                                partnerType={props.partnerType}
                                               
                                            />     
                                            <ContractTab
                                                isActive={activeTab === 'CONTRACT'}
                                                entityId={selectedRecord}
                                                entityName="partner"       
                                                                                      
                                            />                                         
                                            <BankAccountsTab
                                                isActive={activeTab === 'BANK_ACCOUNT'}
                                                entityId={selectedRecord}
                                                entityName="partner"
                                               
                                                
                                            />                                          
                                            <FileTab
                                                isActive={activeTab === 'FILES'}
                                                entityId={selectedRecord}                                                                                                                                                
                                            />    
                                        </div>
                                    </div>
                                </div>   
                            </div>                         
             
                            </Modal.Body>                   
                                        
                  </Modal>   
      </>
    );
};

 
 export default PartnerModal;


 